import { useContext, useEffect, useState } from 'react';
import notificationsAPI from '../../services/NotificationsApi';
import { todayDate, todayLastYear, YMD_FORMAT } from '../../utils/DateUtils';
import { AppContext } from '../../contexts/AppContext';
import { isOptionAllAreas } from '../../components/AreaSelect';

const useNotificationsPresenter = isSupplier => {
  const { showError, showWarning } = useContext(AppContext);

  const [open, setOpen] = useState(false);
  const [rows, setRows] = useState([]);

  const [area, setArea] = useState('');
  const [title, setTitle] = useState('');
  const [dateFrom, setDateFrom] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [loading, setLoading] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);

  const cleanFilters = () => {
    setArea('');
    setTitle('');
    setDateFrom(null);
    setDateTo(null);
  };

  const getRows = filters => {
    setLoading(true);

    const notificationsCall = isSupplier
      ? notificationsAPI.getSupplierNotifications(filters)
      : notificationsAPI.getUserNotifications(filters);

    notificationsCall
      .then(res => {
        setRows(res);
        setLoading(false);
      })
      .catch(error => {
        showError('Error al buscar notificaciones');
        setLoading(false);
      });
  };

  const validateFilters = () => {
    let errors = [];
    const errorMessages = [];

    if ((errors[0] = dateFrom && !dateTo)) {
      errorMessages.push('Debe completar el rango de fechas o quitar la Fecha desde');
    }

    if ((errors[1] = !dateFrom && dateTo)) {
      errorMessages.push('Debe completar el rango de fechas o quitar la Fecha hasta');
    }

    const hasErrors = errors.some(e => e);

    hasErrors && showWarning(errorMessages);

    return !hasErrors;
  };

  const validateAndSearch = () => validateFilters() && search();

  useEffect(() => {
    isSupplier && getRows({ StartDate: todayLastYear(), EndDate: todayDate() });
  }, []);

  const search = () => {
    const request = {
      IdArea: !isOptionAllAreas(area) ? area : undefined,
      Title: !title.isBlank() ? title : undefined,
      StartDate: dateFrom ? dateFrom.format(YMD_FORMAT) : todayLastYear(),
      EndDate: dateTo ? dateTo.format(YMD_FORMAT) : todayDate(),
    };

    setFirstLoad(false);
    getRows(request);
  };

  return {
    open,
    setOpen,
    rows,
    setRows,
    firstLoad,
    loading,
    area,
    setArea,
    title,
    setTitle,
    dateFrom,
    setDateFrom,
    dateTo,
    setDateTo,
    validateAndSearch,
    search,
    cleanFilters,
  };
};

export default useNotificationsPresenter;
